import React, { Component, Fragment } from "react";
import LoginTabset from "./loginTabset";
import { Anchor, Navigation, Truck, Shield } from "react-feather";
import "./login.css";
import { connect } from "react-redux";
import AlgLogo from "../invoice/alg.png";

const SERVICES = [
  { icon: Anchor, label: "Sea freight" },
  { icon: Navigation, label: "Air freight" },
  { icon: Truck, label: "Door-to-door" },
  { icon: Shield, label: "Customs cleared" },
];

export class Login extends Component {
  render() {
    return (
      <Fragment>
        <div className="alg-login-page">
          <div className="alg-split">
            <div className="alg-brand-panel">
              <div className="alg-mark">
                <span className="alg-mark-badge">
                  <img src={AlgLogo} alt="ALG" />
                </span>
                <span className="alg-mark-text">
                  <strong>ALG</strong>
                  <span>Cargo &amp; Logistics</span>
                </span>
              </div>

              <div>
                <div className="alg-headline-block">
                  <span className="alg-eyebrow">Manifest control center</span>
                  <h1 className="alg-headline">
                    Every shipment, tracked from port to doorstep.
                  </h1>
                  <p className="alg-subcopy">
                    Sea and air freight, sourcing, and door-to-door delivery
                    for importers across Bangladesh — run from one control
                    panel.
                  </p>
                </div>

                <div className="alg-route">
                  <div className="alg-route-track">
                    <span className="alg-route-dot is-origin" />
                    <span className="alg-route-dot is-hub" />
                    <span className="alg-route-dot is-dest" />
                    <span className="alg-route-cargo">
                      <Truck />
                    </span>
                  </div>
                  <div className="alg-route-labels">
                    <div>
                      <b>DAC</b>
                      <small>Dhaka</small>
                    </div>
                    <div style={{ alignItems: "center" }}>
                      <b>DXB</b>
                      <small>Transit hub</small>
                    </div>
                    <div>
                      <b>CAN</b>
                      <small>Guangzhou</small>
                    </div>
                  </div>
                </div>

                <div className="alg-services">
                  {SERVICES.map(({ icon: Icon, label }) => (
                    <div className="alg-service" key={label}>
                      <Icon />
                      <span>{label}</span>
                    </div>
                  ))}
                </div>
              </div>

              <p className="alg-brand-foot">
                Built for the team moving Bangladesh&apos;s imports, one
                manifest at a time.
              </p>
            </div>

            <div className="alg-form-panel">
              <div className="alg-card-wrap">
                <div className="alg-mobile-mark">
                  <span className="alg-mark-badge">
                    <img src={AlgLogo} alt="ALG" />
                  </span>
                  <span className="alg-mark-text">
                    <strong>ALG</strong>
                    <span>Cargo &amp; Logistics</span>
                  </span>
                </div>
                <div className="alg-card-eyebrow">
                  <span>Staff &amp; partner access</span>
                </div>
                <div className="alg-card">
                  <div className="alg-card-header">
                    <span className="alg-card-title">MANIFEST ACCESS</span>
                    <span className="alg-card-status">SYSTEM ONLINE</span>
                  </div>
                  <div className="alg-perforation" />
                  <LoginTabset
                    setCurrentAdmin={this.props.setCurrentAdmin}
                    currentAdmin={this.props.currentAdmin}
                  />
                </div>
                <p className="alg-form-footer">
                  © {new Date().getFullYear()} ALG Cargos and Logistics Ltd.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
  };
};
export default connect(mapStateToProps)(Login);
